<template>
  <div class="manual-entry-essential-needs-calculator">
    <div class="row">
      <div class="col s12">
        <div
          class="card"
          v-for="(item, key, index) in calculations"
          :key="index"
        >
          <div class="card-content row no-margins" v-if="key !== 'subTotal'">
            <div class="col s12 no-padding title-section">
              <div class="item-title left">{{ item.title }}</div>
              <div class="right">
                <span class="inner-label"
                  >Total Water Consumption for 2 weeks:
                </span>
                <span class="inner-value"
                  >{{ $_displayFormat(item.totalConsumption) }} gallons</span
                >
              </div>
            </div>
            <div class="row no-margins no-padding labels">
              <div class="col s6 no-padding">
                Enter Total Consumption (gallons)
              </div>
              <div class="col s6">
                Explain Calculation
              </div>
            </div>
            <div class="row no-margins no-padding">
              <div class="col s6 no-padding ">
                <input
                  :id="`${key}_water_consumption_rating`"
                  type="number"
                  placeholder="0"
                  min="0"
                  :value="item.totalConsumption"
                  class="validate"
                  @input="$_calculateTotal($event, key, 'totalConsumption')"
                />
              </div>
              <div class="col s6">
                <textarea
                  class="materialize-textarea"
                  placeholder="explanation"
                  @input="
                    $_calculateTotal($event, key, 'calculationExplanation')
                  "
                  :value="item.calculationExplanation"
                ></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-content">
            <div class="floating-details right" style="padding-right:8px">
              Subtotal: {{ subTotalX }} gallons
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import M from "materialize-css";

export default {
  name: "ManualEntryEssentialNeedsCalculator",
  components: {},
  props: {
    dataValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      calculations: {
        showering: {
          title: "Bathing",
          calculationExplanation: "",
          totalConsumption: 0,
        },
        personalHygiene: {
          title: "Personal Hygiene",
          calculationExplanation: "",
          totalConsumption: 0,
        },
        cleanSurfaces: {
          title: "Cleaning Surfaces",
          calculationExplanation: "",
          totalConsumption: 0,
        },
        cooking: {
          title: "Cooking",
          calculationExplanation: "",
          totalConsumption: 0,
        },
      },
    };
  },
  mounted() {
    this.updateTextFields();
    this.$_getData();
    this.$emit("update", this.formDataX);
    this.$_performEmptyCheck();
  },
  computed: {
    subTotalX() {
      const val =
        parseFloat(this.calculations.showering.totalConsumption || 0) +
        parseFloat(this.calculations.personalHygiene.totalConsumption || 0) +
        parseFloat(this.calculations.cleanSurfaces.totalConsumption || 0) +
        parseFloat(this.calculations.cooking.totalConsumption || 0);
      return val.toFixed(2);
    },
    formDataX() {
      return {
        ...this.calculations,
        subTotal: this.subTotalX,
      };
    },
  },
  watch: {
    subTotalX() {
      this.$emit("update", this.formDataX);
    },
  },
  methods: {
    updateTextFields() {
      setTimeout(() => {
        M.updateTextFields();
      });
    },
    $_displayFormat(val) {
      if (!val) return 0;
      let newVal = parseInt(val);
      newVal = newVal.toLocaleString("en-Us", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      return newVal;
    },
    $_getData() {
      if (this.dataValue && Object.keys(this.dataValue).length > 0) {
        let newObj = { ...this.dataValue };
        delete newObj.subTotal;
        Object.assign(this.calculations, newObj);
      }
    },
    $_calculateTotal({ target: { value } }, prop, key) {
      let val = value;
      if (prop === "totalConsumption") val = parseFloat(val).toFixed(2);

      this.$set(this.calculations[prop], key, val);

      this.$_performEmptyCheck();
    },
    $_performEmptyCheck() {
      const val = Object.values(this.calculations).some(
        ({ calculationExplanation, totalConsumption }) =>
          calculationExplanation || totalConsumption
      );

      this.$emit("nonStandardEnable", val);
    },
  },
};
</script>
<style lang="scss" scoped>
.labels-header {
  display: inline-block;
  padding: 12px 2px;
  font-size: 12px;
  font-weight: 500;
  width: 100%;
  margin-top: -8px;
  z-index: 9;
  left: 0;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.title-col {
  font-size: 20px;
  /*   margin-bottom: 6px; */
}
.section-row {
  display: inline-block;
  width: 100%;
  .heading {
    background: #5374f8;
    margin: 0 0 8px 0px;
    border-radius: 5px;
    padding: 7px;
    font-size: 15px;
    color: white;
    i {
      margin-right: 4px;
      font-size: 18px;
      line-height: 22px;
    }
  }
}
.section-total {
  padding: 9px 5px;
  margin-bottom: 5px;
  border-radius: 6px;
  .total-bar {
    font-size: 20px;
    line-height: 36px;
  }
}
.manual-entry-essential-needs-calculator {
  /*   input {
    border: 1.5px solid rgba(0,0,0,0.2) !important;
  } */
  margin: 0px !important;
  .is-relative {
    position: relative;
  }
  .card {
    .card-content {
      padding: 24px !important;
      .column-row {
        display: inline-flex;
        border-bottom: 1px solid #d5d5d5;
        margin: 0px 10px;
        width: calc(100% - 12px);
        padding: 8px 0px;
        .label-meta {
          width: 100%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          font-size: 16px;
        }
        input {
          margin-bottom: 0px;
        }
      }
    }
    .card-title {
      padding: 0px;
      font-size: 20px;
      margin: 0px;
      line-height: 22px;
      padding-bottom: 12px;
      display: flex;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      i {
        float: left;
        margin-right: 8px;
        line-height: 22px;
      }
      /*  .details {

      } */
    }
    .input-field {
      margin-bottom: 0px;
    }
    .custom-label {
      font-size: 15px;
      letter-spacing: 0.5px;
      /*    margin-bottom: 8px; */
    }
    .total-field {
      margin-top: 14px !important;
    }
    .total-value {
      font-size: 28px;
    }
  }
  .floating-details {
    font-size: 26px;
  }
}
.title-section {
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  margin: 0px 0px 16px;
  padding-bottom: 12px !important;
}

.item-title {
  font-size: 20px;
  margin-bottom: 6px;
  color: #5374f8;
  line-height: 24px;
}
span {
  &.inner-label {
    font-weight: 600 !important;
  }
  &.inner-value {
    font-weight: 600;
    color: #3e5cd4;
  }
}
</style>
